import { useCallback, useState } from "react";
import { debounce } from "lodash";
import { Column } from "../../system-design/Table/DSBaseTable/components/DSBaseTable";
import useCalendarEventsInfiniteQuery from "./useCalendarEventsInfiniteQuery";
import { CalendarEvent } from "../../../api/calendarEvent";

const useCalendarEventsList = () => {
  const [textSearch, setTextSearch] = useState<string>("");

  const { data, fetchNextPage, ...rest } =
    useCalendarEventsInfiniteQuery(textSearch);

  const handleTextSearch = useCallback(
    debounce((text: string) => setTextSearch(text), 500),
    [],
  );

  const columns: Column<CalendarEvent>[] = [
    { field: "name", label: "Name" },
    { field: "date", label: "Date" },
    { field: "country", label: "Country" },
    { field: "primaryType", label: "Primary Type" },
  ];

  return {
    data,
    fetchNextPage,
    ...rest,
    handleTextSearch,
    columns,
  };
};

export default useCalendarEventsList;
